import { Role } from './role';

export class User {
  id: number;
  name: string;
  email: string;
  password: string;
  avatar: string;
  role: Role;
  token?: string;
}
